module.exports = __webpack_public_path__ + "static/media/students.54c2ca3c.jpg";